export const Chest = ({ title }: { title: string }) => (
	<svg width="100%" viewBox="0 0 503 503" fill="none" xmlns="http://www.w3.org/2000/svg" role="img">
		<title>{title}</title>
		<mask id="mask0_7253_121797" style={{ maskType: 'alpha' }} maskUnits="userSpaceOnUse" x="39" y="72" width="425" height="359">
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M405.429 431C441.722 392.878 464 341.291 464 284.5C464 167.139 368.861 72 251.5 72C134.139 72 39 167.139 39 284.5C39 341.291 61.2777 392.878 97.5709 431H405.429Z"
				fill="#D4E3FC"
			/>
		</mask>
		<g mask="url(#mask0_7253_121797)">
			<circle cx="251.5" cy="284.5" r="212.5" fill="#D4CCFF" />
			<mask id="mask1_7253_121797" style={{ maskType: 'alpha' }} maskUnits="userSpaceOnUse" x="127" y="251" width="249" height="180">
				<g style={{ mixBlendMode: 'multiply' }}>
					<path
						fillRule="evenodd"
						clipRule="evenodd"
						d="M166 251C144.461 251 127 268.461 127 290V319V431H376V319V290C376 268.461 358.539 251 337 251H166Z"
						fill="#A26A47"
						fillOpacity="0.9"
					/>
				</g>
			</mask>
			<g mask="url(#mask1_7253_121797)">
				<rect x="127" y="319" width="249" height="112" fill="#A26A47" fillOpacity="0.9" />
				<g style={{ mixBlendMode: 'multiply' }}>
					<path d="M127 290C127 268.461 144.461 251 166 251H337C358.539 251 376 268.461 376 290V319H127V290Z" fill="#A26A47" fillOpacity="0.9" />
				</g>
				<g style={{ mixBlendMode: 'multiply' }}>
					<rect x="296" y="319" width="80" height="112" fill="#A26A47" fillOpacity="0.9" />
				</g>
				<g style={{ mixBlendMode: 'multiply' }}>
					<path d="M296 291C296 268.909 313.909 251 336 251C358.091 251 376 268.909 376 291V319H296V291Z" fill="#A26A47" fillOpacity="0.9" />
				</g>
				<path d="M318 247H311C288.909 247 271 264.909 271 287V431" stroke="#FFBA1A" strokeWidth="8" />
				<path d="M198 247H191C168.909 247 151 264.909 151 287V431" stroke="#FFBA1A" strokeWidth="8" />
				<rect x="127" y="319" width="169" height="9" fill="#FFBA1A" />
				<rect opacity="0.8" width="80" height="9" transform="matrix(-1 0 0 1 376 319)" fill="#CC9514" />
				<g style={{ mixBlendMode: 'multiply' }} opacity="0.5">
					<rect x="127" y="328" width="249" height="2" fill="#A26A47" fillOpacity="0.5" />
				</g>
				<rect x="192" y="304" width="38" height="39" rx="10" fill="#FFBA1A" />
				<g style={{ mixBlendMode: 'multiply' }}>
					<path
						fillRule="evenodd"
						clipRule="evenodd"
						d="M214.285 324.676C216.488 323.571 218 321.291 218 318.657C218 314.94 214.987 311.927 211.27 311.927C207.552 311.927 204.539 314.94 204.539 318.657C204.539 321.291 206.051 323.571 208.255 324.676L206.591 335.073H215.948L214.285 324.676Z"
						fill="#3B4044"
					/>
				</g>
				<g style={{ mixBlendMode: 'multiply' }} opacity="0.5">
					<rect x="127" y="407" width="249" height="2" fill="#A26A47" fillOpacity="0.5" />
				</g>
				<g style={{ mixBlendMode: 'multiply' }} opacity="0.5">
					<rect x="127" y="380" width="249" height="2" fill="#A26A47" fillOpacity="0.5" />
				</g>
				<g style={{ mixBlendMode: 'multiply' }} opacity="0.5">
					<rect x="127" y="298" width="249" height="2" fill="#A26A47" fillOpacity="0.5" />
				</g>
				<g style={{ mixBlendMode: 'multiply' }} opacity="0.5">
					<rect x="127" y="352" width="249" height="2" fill="#A26A47" fillOpacity="0.5" />
				</g>
				<g style={{ mixBlendMode: 'multiply' }} opacity="0.5">
					<rect x="127" y="272" width="249" height="2" fill="#A26A47" fillOpacity="0.5" />
				</g>
				<g style={{ mixBlendMode: 'multiply' }} opacity="0.5">
					<rect x="127" y="257" width="249" height="2" fill="#A26A47" fillOpacity="0.5" />
				</g>
			</g>
			<g style={{ mixBlendMode: 'multiply' }}>
				<path
					fillRule="evenodd"
					clipRule="evenodd"
					d="M483.902 145.016L494.898 134.02C498.837 130.081 498.837 123.695 494.898 119.755C490.959 115.816 484.572 115.816 480.633 119.755L469.637 130.751C465.698 134.691 465.698 141.077 469.637 145.016C473.576 148.956 479.963 148.956 483.902 145.016ZM502.031 112.623C494.152 104.744 481.379 104.744 473.501 112.623L462.505 123.619C454.626 131.497 454.626 144.271 462.505 152.149C470.383 160.027 483.156 160.027 491.035 152.149L502.031 141.153C509.909 133.275 509.909 120.501 502.031 112.623Z"
					fill="#808F99"
				/>
				<path
					fillRule="evenodd"
					clipRule="evenodd"
					d="M478.256 136.398C476.122 134.264 472.663 134.264 470.529 136.398L438.73 168.197C436.596 170.331 436.596 173.791 438.73 175.924C440.864 178.058 444.323 178.058 446.457 175.924L478.256 144.125C480.39 141.991 480.39 138.532 478.256 136.398Z"
					fill="#808F99"
				/>
				<path
					fillRule="evenodd"
					clipRule="evenodd"
					d="M436.352 192.567L447.348 181.571C451.287 177.632 451.287 171.245 447.348 167.306C443.409 163.367 437.022 163.367 433.083 167.306L422.087 178.302C418.148 182.241 418.148 188.628 422.087 192.567C426.026 196.506 432.413 196.506 436.352 192.567ZM454.48 160.173C446.602 152.295 433.829 152.295 425.95 160.173L414.954 171.169C407.076 179.048 407.076 191.821 414.954 199.699C422.833 207.578 435.606 207.578 443.484 199.699L454.48 188.703C462.359 180.825 462.359 168.052 454.48 160.173Z"
					fill="#808F99"
				/>
				<path
					fillRule="evenodd"
					clipRule="evenodd"
					d="M430.705 183.948C428.572 181.815 425.112 181.815 422.978 183.948L391.179 215.748C389.045 217.881 389.045 221.341 391.179 223.475C393.313 225.608 396.772 225.608 398.906 223.475L430.705 191.675C432.839 189.542 432.839 186.082 430.705 183.948Z"
					fill="#808F99"
				/>
				<path
					fillRule="evenodd"
					clipRule="evenodd"
					d="M388.802 240.117L399.798 229.121C403.737 225.182 403.737 218.795 399.798 214.856C395.858 210.917 389.472 210.917 385.532 214.856L374.536 225.852C370.597 229.791 370.597 236.178 374.536 240.117C378.476 244.056 384.862 244.056 388.802 240.117ZM406.93 207.723C399.052 199.845 386.278 199.845 378.4 207.723L367.404 218.719C359.526 226.598 359.526 239.371 367.404 247.25C375.282 255.128 388.056 255.128 395.934 247.25L406.93 236.254C414.809 228.375 414.809 215.602 406.93 207.723Z"
					fill="#808F99"
				/>
				<path
					fillRule="evenodd"
					clipRule="evenodd"
					d="M383.155 231.499C381.021 229.365 377.562 229.365 375.428 231.499L343.629 263.298C341.495 265.432 341.495 268.891 343.629 271.025C345.762 273.159 349.222 273.159 351.356 271.025L383.155 239.226C385.289 237.092 385.289 233.632 383.155 231.499Z"
					fill="#808F99"
				/>
				<path
					fillRule="evenodd"
					clipRule="evenodd"
					d="M341.251 287.667L352.247 276.671C356.186 272.732 356.186 266.346 352.247 262.406C348.308 258.467 341.921 258.467 337.982 262.406L326.986 273.402C323.047 277.342 323.047 283.728 326.986 287.667C330.925 291.607 337.312 291.607 341.251 287.667ZM359.38 255.274C351.501 247.395 338.728 247.395 330.85 255.274L319.854 266.27C311.975 274.148 311.975 286.922 319.854 294.8C327.732 302.678 340.505 302.678 348.384 294.8L359.38 283.804C367.258 275.926 367.258 263.152 359.38 255.274Z"
					fill="#808F99"
				/>
				<path
					fillRule="evenodd"
					clipRule="evenodd"
					d="M335.605 279.049C333.471 276.915 330.011 276.915 327.878 279.049L296.078 310.848C293.945 312.982 293.945 316.442 296.078 318.575C298.212 320.709 301.672 320.709 303.805 318.575L335.605 286.776C337.738 284.642 337.738 281.183 335.605 279.049Z"
					fill="#808F99"
				/>
				<path
					fillRule="evenodd"
					clipRule="evenodd"
					d="M293.701 335.218L304.697 324.222C308.636 320.283 308.636 313.896 304.697 309.957C300.758 306.017 294.371 306.017 290.432 309.957L279.436 320.953C275.497 324.892 275.497 331.279 279.436 335.218C283.375 339.157 289.762 339.157 293.701 335.218ZM311.83 302.824C303.951 294.946 291.178 294.946 283.299 302.824L272.303 313.82C264.425 321.699 264.425 334.472 272.303 342.35C280.182 350.229 292.955 350.229 300.834 342.35L311.83 331.354C319.708 323.476 319.708 310.703 311.83 302.824Z"
					fill="#808F99"
				/>
				<path
					fillRule="evenodd"
					clipRule="evenodd"
					d="M288.054 326.599C285.921 324.466 282.461 324.466 280.327 326.599L248.528 358.399C246.394 360.532 246.394 363.992 248.528 366.126C250.662 368.259 254.121 368.259 256.255 366.126L288.054 334.326C290.188 332.193 290.188 328.733 288.054 326.599Z"
					fill="#808F99"
				/>
				<path
					fillRule="evenodd"
					clipRule="evenodd"
					d="M246.151 382.768L257.147 371.772C261.086 367.833 261.086 361.446 257.147 357.507C253.208 353.568 246.821 353.568 242.882 357.507L231.886 368.503C227.946 372.442 227.946 378.829 231.886 382.768C235.825 386.707 242.211 386.707 246.151 382.768ZM264.279 350.374C256.401 342.496 243.627 342.496 235.749 350.374L224.753 361.37C216.875 369.249 216.875 382.022 224.753 389.901C232.631 397.779 245.405 397.779 253.283 389.901L264.279 378.905C272.158 371.026 272.158 358.253 264.279 350.374Z"
					fill="#808F99"
				/>
				<path
					fillRule="evenodd"
					clipRule="evenodd"
					d="M240.504 374.15C238.37 372.016 234.911 372.016 232.777 374.15L200.978 405.949C198.844 408.083 198.844 411.542 200.978 413.676C203.112 415.81 206.571 415.81 208.705 413.676L240.504 381.877C242.638 379.743 242.638 376.283 240.504 374.15Z"
					fill="#808F99"
				/>
				<path
					fillRule="evenodd"
					clipRule="evenodd"
					d="M198.6 430.318L209.596 419.322C213.536 415.383 213.536 408.997 209.596 405.057C205.657 401.118 199.271 401.118 195.331 405.057L184.335 416.053C180.396 419.993 180.396 426.379 184.335 430.318C188.275 434.258 194.661 434.258 198.6 430.318ZM216.729 397.925C208.851 390.046 196.077 390.046 188.199 397.925L177.203 408.921C169.324 416.799 169.324 429.573 177.203 437.451C185.081 445.329 197.855 445.329 205.733 437.451L216.729 426.455C224.607 418.577 224.607 405.803 216.729 397.925Z"
					fill="#808F99"
				/>
				<path
					fillRule="evenodd"
					clipRule="evenodd"
					d="M192.954 421.7C190.82 419.566 187.361 419.566 185.227 421.7L153.428 453.499C151.294 455.633 151.294 459.092 153.428 461.226C155.561 463.36 159.021 463.36 161.155 461.226L192.954 429.427C195.088 427.293 195.088 423.834 192.954 421.7Z"
					fill="#808F99"
				/>
			</g>
			<g style={{ mixBlendMode: 'multiply' }}>
				<path
					fillRule="evenodd"
					clipRule="evenodd"
					d="M463.612 83.5199L478.633 79.4951C484.014 78.0532 487.207 72.5222 485.765 67.1411C484.323 61.7601 478.792 58.5667 473.411 60.0086L458.39 64.0334C453.009 65.4753 449.816 71.0063 451.258 76.3873C452.7 81.7684 458.231 84.9617 463.612 83.5199ZM495.508 64.5304C492.625 53.7684 481.563 47.3817 470.801 50.2653L455.78 54.2902C445.018 57.1739 438.631 68.236 441.515 78.998C444.398 89.7601 455.46 96.1468 466.223 93.2631L481.243 89.2383C492.005 86.3546 498.392 75.2925 495.508 64.5304Z"
					fill="#808F99"
				/>
				<path
					fillRule="evenodd"
					clipRule="evenodd"
					d="M463.031 73.2328C462.25 70.3181 459.254 68.5884 456.34 69.3694L412.901 81.0087C409.986 81.7897 408.257 84.7857 409.038 87.7004C409.819 90.6151 412.814 92.3449 415.729 91.5639L459.168 79.9245C462.083 79.1435 463.812 76.1476 463.031 73.2328Z"
					fill="#808F99"
				/>
				<path
					fillRule="evenodd"
					clipRule="evenodd"
					d="M398.657 100.925L413.678 96.8997C419.059 95.4579 422.253 89.9268 420.811 84.5458C419.369 79.1647 413.838 75.9714 408.457 77.4132L393.436 81.438C388.055 82.8799 384.862 88.4109 386.303 93.792C387.745 99.173 393.276 102.366 398.657 100.925ZM430.554 81.9351C427.67 71.173 416.608 64.7863 405.846 67.67L390.825 71.6948C380.063 74.5785 373.676 85.6406 376.56 96.4027C379.444 107.165 390.506 113.551 401.268 110.668L416.289 106.643C427.051 103.759 433.438 92.6972 430.554 81.9351Z"
					fill="#808F99"
				/>
				<path
					fillRule="evenodd"
					clipRule="evenodd"
					d="M398.076 90.6375C397.295 87.7227 394.299 85.993 391.385 86.774L347.946 98.4133C345.031 99.1943 343.301 102.19 344.082 105.105C344.863 108.02 347.859 109.75 350.774 108.969L394.213 97.3292C397.128 96.5482 398.857 93.5522 398.076 90.6375Z"
					fill="#808F99"
				/>
				<path
					fillRule="evenodd"
					clipRule="evenodd"
					d="M333.702 118.329L348.723 114.304C354.104 112.862 357.297 107.331 355.856 101.95C354.414 96.5693 348.883 93.376 343.502 94.8178L328.481 98.8427C323.1 100.285 319.906 105.816 321.348 111.197C322.79 116.578 328.321 119.771 333.702 118.329ZM365.599 99.3397C362.715 88.5776 351.653 82.1909 340.891 85.0746L325.87 89.0994C315.108 91.9831 308.721 103.045 311.605 113.807C314.489 124.569 325.551 130.956 336.313 128.072L351.334 124.048C362.096 121.164 368.483 110.102 365.599 99.3397Z"
					fill="#808F99"
				/>
				<path
					fillRule="evenodd"
					clipRule="evenodd"
					d="M333.121 108.042C332.34 105.127 329.344 103.398 326.429 104.179L282.991 115.818C280.076 116.599 278.346 119.595 279.127 122.51C279.908 125.424 282.904 127.154 285.819 126.373L329.258 114.734C332.172 113.953 333.902 110.957 333.121 108.042Z"
					fill="#808F99"
				/>
				<path
					fillRule="evenodd"
					clipRule="evenodd"
					d="M268.747 135.734L283.768 131.709C289.149 130.267 292.342 124.736 290.901 119.355C289.459 113.974 283.928 110.781 278.547 112.222L263.526 116.247C258.145 117.689 254.951 123.22 256.393 128.601C257.835 133.982 263.366 137.176 268.747 135.734ZM300.644 116.744C297.76 105.982 286.698 99.5956 275.936 102.479L260.915 106.504C250.153 109.388 243.766 120.45 246.65 131.212C249.534 141.974 260.596 148.361 271.358 145.477L286.379 141.452C297.141 138.569 303.527 127.506 300.644 116.744Z"
					fill="#808F99"
				/>
				<path
					fillRule="evenodd"
					clipRule="evenodd"
					d="M268.167 125.447C267.386 122.532 264.39 120.802 261.475 121.583L218.036 133.223C215.121 134.004 213.392 137 214.173 139.914C214.954 142.829 217.95 144.559 220.864 143.778L264.303 132.138C267.218 131.357 268.948 128.361 268.167 125.447Z"
					fill="#808F99"
				/>
				<path
					fillRule="evenodd"
					clipRule="evenodd"
					d="M203.793 153.138L218.813 149.114C224.194 147.672 227.388 142.141 225.946 136.76C224.504 131.379 218.973 128.185 213.592 129.627L198.571 133.652C193.19 135.094 189.997 140.625 191.439 146.006C192.88 151.387 198.411 154.58 203.793 153.138ZM235.689 134.149C232.805 123.387 221.743 117 210.981 119.884L195.96 123.909C185.198 126.792 178.812 137.854 181.695 148.617C184.579 159.379 195.641 165.765 206.403 162.882L221.424 158.857C232.186 155.973 238.573 144.911 235.689 134.149Z"
					fill="#808F99"
				/>
				<path
					fillRule="evenodd"
					clipRule="evenodd"
					d="M203.211 142.851C202.43 139.937 199.435 138.207 196.52 138.988L153.081 150.627C150.166 151.408 148.437 154.404 149.218 157.319C149.999 160.234 152.995 161.963 155.909 161.182L199.348 149.543C202.263 148.762 203.992 145.766 203.211 142.851Z"
					fill="#808F99"
				/>
				<path
					fillRule="evenodd"
					clipRule="evenodd"
					d="M138.837 170.543L153.858 166.518C159.239 165.076 162.433 159.545 160.991 154.164C159.549 148.783 154.018 145.59 148.637 147.032L133.616 151.057C128.235 152.498 125.042 158.029 126.484 163.41C127.925 168.792 133.456 171.985 138.837 170.543ZM170.734 151.554C167.85 140.792 156.788 134.405 146.026 137.288L131.005 141.313C120.243 144.197 113.857 155.259 116.74 166.021C119.624 176.783 130.686 183.17 141.448 180.286L156.469 176.261C167.231 173.378 173.618 162.316 170.734 151.554Z"
					fill="#808F99"
				/>
				<path
					fillRule="evenodd"
					clipRule="evenodd"
					d="M138.256 160.256C137.475 157.341 134.479 155.612 131.565 156.393L88.1261 168.032C85.2113 168.813 83.4816 171.809 84.2626 174.724C85.0436 177.638 88.0396 179.368 90.9543 178.587L134.393 166.948C137.308 166.167 139.037 163.171 138.256 160.256Z"
					fill="#808F99"
				/>
				<path
					fillRule="evenodd"
					clipRule="evenodd"
					d="M73.8824 187.948L88.9032 183.923C94.2843 182.481 97.4776 176.95 96.0358 171.569C94.5939 166.188 89.0629 162.995 83.6818 164.436L68.661 168.461C63.28 169.903 60.0866 175.434 61.5284 180.815C62.9703 186.196 68.5013 189.39 73.8824 187.948ZM105.779 168.958C102.895 158.196 91.8332 151.809 81.0711 154.693L66.0503 158.718C55.2882 161.602 48.9015 172.664 51.7852 183.426C54.6689 194.188 65.731 200.575 76.4931 197.691L91.5139 193.666C102.276 190.782 108.663 179.72 105.779 168.958Z"
					fill="#808F99"
				/>
				<path
					fillRule="evenodd"
					clipRule="evenodd"
					d="M73.3013 177.661C72.5203 174.746 69.5244 173.016 66.6096 173.797L23.171 185.436C20.2563 186.217 18.5265 189.213 19.3075 192.128C20.0885 195.043 23.0845 196.773 25.9992 195.992L69.4379 184.352C72.3526 183.571 74.0823 180.575 73.3013 177.661Z"
					fill="#808F99"
				/>
				<path
					fillRule="evenodd"
					clipRule="evenodd"
					d="M8.9273 205.352L23.9481 201.327C29.3292 199.886 32.5225 194.355 31.0807 188.974C29.6388 183.593 24.1078 180.399 18.7267 181.841L3.70592 185.866C-1.67513 187.308 -4.86848 192.839 -3.42663 198.22C-1.98478 203.601 3.54626 206.794 8.9273 205.352ZM40.8239 186.363C37.9402 175.601 26.8781 169.214 16.1161 172.098L1.09522 176.123C-9.66686 179.006 -16.0536 190.068 -13.1699 200.83C-10.2862 211.593 0.775912 217.979 11.538 215.096L26.5588 211.071C37.3209 208.187 43.7076 197.125 40.8239 186.363Z"
					fill="#808F99"
				/>
			</g>
			<g style={{ mixBlendMode: 'multiply' }}>
				<path
					fillRule="evenodd"
					clipRule="evenodd"
					d="M23.6011 188.134L8.58029 184.109C3.19924 182.667 -2.3318 185.861 -3.77365 191.242C-5.2155 196.623 -2.02215 202.154 3.3589 203.596L18.3797 207.62C23.7608 209.062 29.2918 205.869 30.7337 200.488C32.1755 195.107 28.9822 189.576 23.6011 188.134ZM-13.5169 188.631C-16.4006 199.393 -10.0139 210.455 0.748204 213.339L15.769 217.364C26.5311 220.247 37.5932 213.861 40.4769 203.099C43.3606 192.337 36.9739 181.274 26.2118 178.391L11.191 174.366C0.428891 171.482 -10.6332 177.869 -13.5169 188.631Z"
					fill="#808F99"
				/>
				<path
					fillRule="evenodd"
					clipRule="evenodd"
					d="M18.961 197.333C18.18 200.248 19.9097 203.244 22.8245 204.025L66.2631 215.664C69.1778 216.445 72.1738 214.716 72.9548 211.801C73.7358 208.886 72.0061 205.89 69.0913 205.109L25.6527 193.47C22.738 192.689 19.742 194.419 18.961 197.333Z"
					fill="#808F99"
				/>
				<path
					fillRule="evenodd"
					clipRule="evenodd"
					d="M88.5562 205.539L73.5354 201.514C68.1543 200.072 62.6233 203.265 61.1814 208.646C59.7396 214.027 62.9329 219.558 68.314 221L83.3348 225.025C88.7159 226.467 94.2469 223.274 95.6887 217.893C97.1306 212.512 93.9372 206.98 88.5562 205.539ZM51.4382 206.036C48.5545 216.798 54.9412 227.86 65.7033 230.744L80.7241 234.768C91.4862 237.652 102.548 231.265 105.432 220.503C108.316 209.741 101.929 198.679 91.1669 195.795L76.1461 191.771C65.384 188.887 54.3219 195.274 51.4382 206.036Z"
					fill="#808F99"
				/>
				<path
					fillRule="evenodd"
					clipRule="evenodd"
					d="M83.9156 214.738C83.1346 217.653 84.8643 220.649 87.7791 221.43L131.218 233.069C134.132 233.85 137.128 232.12 137.909 229.206C138.69 226.291 136.961 223.295 134.046 222.514L90.6073 210.874C87.6926 210.093 84.6966 211.823 83.9156 214.738Z"
					fill="#808F99"
				/>
				<path
					fillRule="evenodd"
					clipRule="evenodd"
					d="M153.511 222.943L138.49 218.918C133.109 217.477 127.578 220.67 126.137 226.051C124.695 231.432 127.888 236.963 133.269 238.405L148.29 242.43C153.671 243.872 159.202 240.678 160.644 235.297C162.086 229.916 158.892 224.385 153.511 222.943ZM116.393 223.44C113.51 234.202 119.896 245.264 130.658 248.148L145.679 252.173C156.441 255.057 167.503 248.67 170.387 237.908C173.271 227.146 166.884 216.084 156.122 213.2L141.101 209.175C130.339 206.291 119.277 212.678 116.393 223.44Z"
					fill="#808F99"
				/>
				<path
					fillRule="evenodd"
					clipRule="evenodd"
					d="M148.871 232.143C148.09 235.057 149.819 238.053 152.734 238.834L196.173 250.474C199.087 251.255 202.083 249.525 202.864 246.61C203.645 243.695 201.916 240.699 199.001 239.918L155.562 228.279C152.648 227.498 149.652 229.228 148.871 232.143Z"
					fill="#808F99"
				/>
				<path
					fillRule="evenodd"
					clipRule="evenodd"
					d="M218.466 240.348L203.446 236.323C198.064 234.881 192.533 238.075 191.092 243.456C189.65 248.837 192.843 254.368 198.224 255.81L213.245 259.834C218.626 261.276 224.157 258.083 225.599 252.702C227.041 247.321 223.847 241.79 218.466 240.348ZM181.348 240.845C178.465 251.607 184.851 262.669 195.613 265.553L210.634 269.578C221.396 272.461 232.458 266.075 235.342 255.313C238.226 244.55 231.839 233.488 221.077 230.605L206.056 226.58C195.294 223.696 184.232 230.083 181.348 240.845Z"
					fill="#808F99"
				/>
				<path
					fillRule="evenodd"
					clipRule="evenodd"
					d="M213.826 249.547C213.045 252.462 214.774 255.458 217.689 256.239L261.128 267.878C264.043 268.659 267.039 266.929 267.82 264.015C268.601 261.1 266.871 258.104 263.956 257.323L220.517 245.684C217.603 244.903 214.607 246.632 213.826 249.547Z"
					fill="#808F99"
				/>
				<path
					fillRule="evenodd"
					clipRule="evenodd"
					d="M283.421 257.752L268.4 253.728C263.019 252.286 257.488 255.479 256.046 260.86C254.604 266.241 257.798 271.772 263.179 273.214L278.2 277.239C283.581 278.681 289.112 275.487 290.553 270.106C291.995 264.725 288.802 259.194 283.421 257.752ZM246.303 258.25C243.419 269.012 249.806 280.074 260.568 282.957L275.589 286.982C286.351 289.866 297.413 283.479 300.297 272.717C303.18 261.955 296.794 250.893 286.032 248.009L271.011 243.984C260.249 241.101 249.187 247.487 246.303 258.25Z"
					fill="#808F99"
				/>
				<path
					fillRule="evenodd"
					clipRule="evenodd"
					d="M278.781 266.952C278 269.866 279.73 272.862 282.644 273.643L326.083 285.283C328.998 286.064 331.994 284.334 332.775 281.419C333.556 278.505 331.826 275.509 328.911 274.728L285.473 263.088C282.558 262.307 279.562 264.037 278.781 266.952Z"
					fill="#808F99"
				/>
				<path
					fillRule="evenodd"
					clipRule="evenodd"
					d="M348.376 275.157L333.355 271.132C327.974 269.69 322.443 272.884 321.001 278.265C319.559 283.646 322.753 289.177 328.134 290.619L343.155 294.644C348.536 296.085 354.067 292.892 355.509 287.511C356.95 282.13 353.757 276.599 348.376 275.157ZM311.258 275.654C308.374 286.416 314.761 297.478 325.523 300.362L340.544 304.387C351.306 307.271 362.368 300.884 365.252 290.122C368.136 279.36 361.749 268.298 350.987 265.414L335.966 261.389C325.204 258.505 314.142 264.892 311.258 275.654Z"
					fill="#808F99"
				/>
				<path
					fillRule="evenodd"
					clipRule="evenodd"
					d="M343.735 284.356C342.954 287.271 344.684 290.267 347.599 291.048L391.038 302.688C393.952 303.469 396.948 301.739 397.729 298.824C398.51 295.909 396.78 292.913 393.866 292.132L350.427 280.493C347.512 279.712 344.516 281.442 343.735 284.356Z"
					fill="#808F99"
				/>
				<path
					fillRule="evenodd"
					clipRule="evenodd"
					d="M413.331 292.562L398.31 288.537C392.929 287.095 387.398 290.288 385.956 295.669C384.514 301.051 387.708 306.582 393.089 308.023L408.11 312.048C413.491 313.49 419.022 310.297 420.464 304.916C421.905 299.535 418.712 294.004 413.331 292.562ZM376.213 293.059C373.329 303.821 379.716 314.883 390.478 317.767L405.499 321.791C416.261 324.675 427.323 318.288 430.207 307.526C433.091 296.764 426.704 285.702 415.942 282.818L400.921 278.794C390.159 275.91 379.097 282.297 376.213 293.059Z"
					fill="#808F99"
				/>
				<path
					fillRule="evenodd"
					clipRule="evenodd"
					d="M408.69 301.761C407.909 304.676 409.639 307.672 412.554 308.453L455.993 320.092C458.907 320.873 461.903 319.143 462.684 316.229C463.465 313.314 461.736 310.318 458.821 309.537L415.382 297.898C412.467 297.117 409.471 298.846 408.69 301.761Z"
					fill="#808F99"
				/>
				<path
					fillRule="evenodd"
					clipRule="evenodd"
					d="M478.286 309.966L463.265 305.942C457.884 304.5 452.353 307.693 450.911 313.074C449.47 318.455 452.663 323.986 458.044 325.428L473.065 329.453C478.446 330.895 483.977 327.701 485.419 322.32C486.861 316.939 483.667 311.408 478.286 309.966ZM441.168 310.463C438.284 321.225 444.671 332.288 455.433 335.171L470.454 339.196C481.216 342.08 492.278 335.693 495.162 324.931C498.046 314.169 491.659 303.107 480.897 300.223L465.876 296.198C455.114 293.315 444.052 299.701 441.168 310.463Z"
					fill="#808F99"
				/>
			</g>
		</g>
	</svg>
);
